export default __webpack_public_path__ + "static/media/nuno.c7efd2d0.jpg";